import { isVisible } from './is-visible.js';

/**
 * Function used for trapping focus inside a given element
 * @param {HTMLElement} element - HTML element where focus should be trapped
 * @returns {function()} - trap focus function
 */
export const trapFocusHandler = (element) => (event) => {
  if (element.contains(event.target)) {
    // eslint-disable-next-line no-param-reassign
    element.gravityLastFocus = event.target;
  } else {
    const allFocusableElements = element.querySelectorAll(
      "a[href]:not([disabled]), a[role='button'], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])",
    );
    const focusableElements = [...allFocusableElements].filter((focusableElement) => isVisible(focusableElement));
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (element.gravityLastFocus === firstFocusableElement) {
      lastFocusableElement.focus();
    } else {
      firstFocusableElement.focus();
    }

    // eslint-disable-next-line no-param-reassign
    element.gravityLastFocus = document.activeElement;
  }
};
